import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay'
import { MatChipsModule } from '@angular/material/chips'
import { MatIcon } from '@angular/material/icon'
import { SingularAutocompleteComponent } from '../../singular-autocomplete/singular-autocomplete.component'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'app-filter',
  standalone: true,
  imports: [CdkConnectedOverlay, CdkOverlayOrigin, MatChipsModule, MatIcon, SingularAutocompleteComponent, TranslateModule],
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss',
})
export class FilterComponent<K extends number | string, T> {
  @Input()
  name!: string

  @Input()
  idKey!: string

  @Input()
  labelKey!: string

  @Input()
  icon!: string

  @Input()
  value: K | null = null

  @Input()
  options!: T[]

  @Input()
  findWith!: (options: T[], id: K) => T | null

  @Input()
  filterWith!: (query: string, options: T[]) => T[]

  @Input()
  displayWith!: (value: T | null) => string

  @Output()
  clear = new EventEmitter<void>()

  @Output()
  optionSelected = new EventEmitter<K>()

  isOpen = false

  sendClear(): void {
    this.isOpen = true
    this.clear.emit()
  }
}
